import { render, staticRenderFns } from "./UserPlansAlterar.vue?vue&type=template&id=cbdc594c&"
import script from "./UserPlansAlterar.vue?vue&type=script&lang=js&"
export * from "./UserPlansAlterar.vue?vue&type=script&lang=js&"
import style0 from "./UserPlansAlterar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports